import { api } from "../config/baseApi";

type DataFromFetchType = {
  success: boolean;
  message: string;
  status: number;
  content: any;
  error?: { message?: string };
};

const timeoutDuration = 35000; // Timeout duration in milliseconds

const createFetchRequest = (
  url: string,
  method: string,
  token?: string,
  body?: any
) => {
  const controller = new AbortController();
  const { signal } = controller;

  const timeoutId = setTimeout(() => {
    controller.abort();
  }, timeoutDuration);

  const headers: HeadersInit = {
    Accept: "application/json",
    "Content-Type": "application/json",
  };

  if (token) {
    headers["Authorization"] = token;
  }

  const request: RequestInit = {
    method,
    headers,
    signal,
  };

  if (body) {
    request.body = JSON.stringify(body);
  }

  return { url, request, timeoutId };
};

const handleFetchError = (error: any): DataFromFetchType => {
  clearTimeout(error.timeoutId);

  if (error.name === "AbortError") {
    return {
      success: false,
      message: "Request timed out",
      status: 500,
      content: {},
    };
  } else {
    console.log(error);
    return {
      success: false,
      message: "Problème de connexion !",
      status: 500,
      content: {},
    };
  }
};

export const filterSearchProducts = (data: any): Promise<DataFromFetchType> => {
  const { url, request, timeoutId } = createFetchRequest(
    `${api}/list-search-filter`,
    "POST",
    undefined,
    data
  );

  return fetch(url, request)
    .then((response: Response) => {
      clearTimeout(timeoutId);
      return response.json();
    })
    .catch(handleFetchError);
};
